module.exports = __webpack_public_path__ + "static/media/dermadvance.9ef75ea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/dermadvance.png
// module id = 143
// module chunks = 0